import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import SinglePage from "./components/SinglePage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookieConsent from "./components/CookieConsent";
import { Toaster } from "./components/ui/sonner";
import { trackPageView } from "./utils/analytics";

// Component to track page views
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <div className="App min-h-screen bg-[#020617]" data-testid="app-container">
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<SinglePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        <CookieConsent />
        <Toaster position="bottom-right" />
      </div>
    </Router>
  );
}

export default App;
